import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=a5acdeec&lang=pug"
import script from "./PriceFilter.vue?vue&type=script&lang=js"
export * from "./PriceFilter.vue?vue&type=script&lang=js"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=a5acdeec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports